import { connect } from 'react-redux';
import { compose } from 'redux';
import { Card, Dropdown, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import DraggableAreaChart from './charts/DraggableAreaChart';
import { getMinutesChart } from '../../../../../../utils/constantValues';
import PropertyTableTimePicker from './components/PropertyTableTimePicker';
import { ASTRO_DIM, ASTRO_DIM8 } from '../../../../../../utils/constantFeatures';
import { getErrorIssues } from '../../../../../../utils/validationSummary';
import * as d3 from 'd3';
import { fetchDriverOpmodesSelected } from '../../../../../../actions';
import AstroSubmodeCluster from './molecules/AstroSubmodeCluster';
import AstroFadeTimingCluster from './molecules/AstroFadeTimingCluster';
import AstroLocationCluster from './molecules/AstroLocationCluster';
import moment from 'moment';
import { fetchDriverProperties, fetchAstroSavings } from '../../../../../../actions';
import { EllipsisText } from '../../../../../shared/EllipsisText';
import { Trans, withTranslation } from 'react-i18next';

class AstroDim extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            savings: 'Calculating...',
            countryKey: 'Custom'
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
        this.handleCountryDropdownChange = this.handleCountryDropdownChange.bind(this);
        this.handleChangeReferenceSchedule = this.handleChangeReferenceSchedule.bind(this);

        // this.onChangeLocation = this.onChangeLocation.bind(this);
    }

    handleChange(propertyName, value) {
        this.setState({ savings: "Calculating..." })
        const v = value;

        //in case this is being called by LocationComponent where there is no propertyName
        if (propertyName) {

            // in case the propery is from another feature
            if ((this.getCorrectPropertyName(propertyName) === ASTRO_DIM8.outputColour1)
                || (this.getCorrectPropertyName(propertyName) === ASTRO_DIM8.outputColour2)
                || (this.getCorrectPropertyName(propertyName) === ASTRO_DIM8.outputColour3)
                || (this.getCorrectPropertyName(propertyName) === ASTRO_DIM8.outputColour4)
                || (this.getCorrectPropertyName(propertyName) === ASTRO_DIM8.outputColour5)
                || (this.getCorrectPropertyName(propertyName) === ASTRO_DIM8.initialColour)
            ) {
                let property = this.props.extraProperties[propertyName];
                property.value = value;
                this.props.handleChangeExtraProperties(property);
            } else {
                this.props.handleChange(propertyName, v);
            }

            if (this.getCorrectPropertyName(propertyName) === ASTRO_DIM.submode) {
                if (value === '0') {
                    this.handleChangeCountry('Custom')
                }
                this.setDefault(v, 0);
            }
        }

        //get new calculated propery values (savings calculation) 2.5 seconds after posting changes to parameters)
        setTimeout(
            () => {
                this.props.fetchAstroSavings(this.props.project.id, this.props.driver.driverId).then(e => {
                    const value = this.props.astroSavingsValue
                    this.setState({ savings: value + "%" });
                });

            },
            2500
        );
    }

    handleChangeReferenceSchedule(propertyName, value) {
        const v = value;
        this.handleChange(propertyName, v);
        this.setState({ countryKey: 'Custom' });
    }

    handleCountryDropdownChange(e) {
        this.handleChangeCountry(e.target.name);
    }

    handleChangeCountry(value) {
        this.setState({ countryKey: value });

        if (value === 'FR – Arrêté nuisances lumineuses') {
            this.props.handleChange(ASTRO_DIM.outputLevel1, '100');
            this.props.handleChange(ASTRO_DIM.outputLevel2, '70');
            this.props.handleChange(ASTRO_DIM.outputLevel3, '50');
            this.props.handleChange(ASTRO_DIM.outputLevel4, '50');
            this.props.handleChange(ASTRO_DIM.outputLevel5, '70');
            this.props.handleChange(ASTRO_DIM.time2, '16:30');
            this.props.handleChange(ASTRO_DIM.time3, '21:30');
            this.props.handleChange(ASTRO_DIM.time4, '07:00');
            this.props.handleChange(ASTRO_DIM.time5, '07:30');
        }
    }

    componentDidMount() {
        this.props.fetchDriverProperties(this.props.project.id, this.props.driver.driverId);

        const value = this.props.properties[ASTRO_DIM.energySavings]?.value || -1
        this.setState({ savings: value + "%" });
        this.handleChange(null, null);
        // this.setState({savings: this.props.properties[ASTRO_DIM.energySavings].value + "%"  })
    }

    setDefault(submode, shift) {

        this.props.handleChange(ASTRO_DIM.outputLevel1, this.props.properties[ASTRO_DIM.outputLevel1].valueMeta.default);
        this.props.handleChange(ASTRO_DIM.outputLevel2, this.props.properties[ASTRO_DIM.outputLevel2].valueMeta.default);
        this.props.handleChange(ASTRO_DIM.outputLevel3, this.props.properties[ASTRO_DIM.outputLevel3].valueMeta.default);
        this.props.handleChange(ASTRO_DIM.outputLevel4, this.props.properties[ASTRO_DIM.outputLevel4].valueMeta.default);
        this.props.handleChange(ASTRO_DIM.outputLevel5, this.props.properties[ASTRO_DIM.outputLevel5].valueMeta.default);

        const myDate = moment(submode === '0' ? '22:00' : (submode === '1' ? '02:00' : '00:00'), 'HH:mm');

        if (shift) {
            myDate.add(shift, 'minutes');
        }

        this.props.handleChange(ASTRO_DIM.time2, myDate.format('HH:mm'));
        this.props.handleChange(ASTRO_DIM.time3, myDate.add(2, 'hours').format('HH:mm'));
        this.props.handleChange(ASTRO_DIM.time4, myDate.add(2, 'hours').format('HH:mm'));
        this.props.handleChange(ASTRO_DIM.time5, myDate.add(2, 'hours').format('HH:mm'));
    }

    getConvertedOffset(value) {

        if (value <= 64) {
            value = value / 4;
        } else {
            value = (value - 128) / 4;
        }

        return value;
    }

    render() {
        const displayColors = this.props.driverFeatures.some(item => item.name === 'ast8');

        var displayLocation = (this.props.properties[ASTRO_DIM.submode].value === '0');

        const submode = this.props.properties[ASTRO_DIM.submode];

        const switchOnFadeTime = this.props.properties[ASTRO_DIM.switchOnFadeTime];
        const switchOffFadeTime = this.props.properties[ASTRO_DIM.switchOffFadeTime];
        const astroDimFadeTime = this.props.properties[ASTRO_DIM.astroDimFadeTime];

        const min = submode.value === '0' ? { x: new Date(1970, 0, 1, 12, 0, 0) } : (submode.value === '1' ? { x: new Date(1970, 0, 1, 0, 0, 0) } : { x: new Date(1969, 11, 31, 22, 0, 0) });
        const max = submode.value === '0' ? { x: new Date(1970, 0, 2, 12, 0, 0), y: 100 } : { x: new Date(1970, 0, 2, 0, 0, 0), y: 100 };

        const tickFormat = { x: d3.timeFormat("%H") };

        const time = [];
        const tickValues = { x: time };
        if (submode.value === '0') {
            for (let i = 12; i < 24; i++) {
                time.push(new Date(1970, 0, 1, i, 0, 0));
            }
            for (let i = 0; i < 13; i++) {
                time.push(new Date(1970, 0, 2, i, 0, 0));
            }
        } else if (submode.value === '1') {
            for (let i = 0; i < 24; i++) {
                time.push(new Date(1970, 0, 1, i, 0, 0));
            }
            time.push(new Date(1970, 0, 2, 0, 0, 0));
        } else if (submode.value === '2') {
            for (let i = 1; i < 24; i++) {
                time.push(new Date(1970, 0, 1, i, 0, 0));
            }
            time.push(new Date(1970, 0, 2, 0, 0, 0));
        }

        const dataChart = this.getDataChart(this.props.properties, submode);
        const { t } = this.props;

        return (
            <div>
                <div className='flex-row'>
                    <AstroSubmodeCluster
                        submode={submode}
                        isSDTriggeredEnabled={this.props.opmodesSelected?.name?.startsWith('astro_pd') ?? false}
                        handleChange={this.handleChange} />

                    <AstroFadeTimingCluster
                        switchOnFadeTime={switchOnFadeTime}
                        astroDimFadeTime={astroDimFadeTime}
                        switchOffFadeTime={switchOffFadeTime}
                        showSwitchOff={submode.value === '0'}
                        className={this.getClassName([astroDimFadeTime, switchOnFadeTime, switchOffFadeTime])}
                        handleChange={this.handleChange} />

                    {displayLocation &&
                        <AstroLocationCluster
                            project={this.props.project}
                            className={this.getClassName([astroDimFadeTime, switchOnFadeTime, switchOffFadeTime])}
                            handleChange={this.handleChange} />
                    }
                </div>
                <div className='flex-row' style={{ paddingTop: '0.75rem', margin: '0' }}>
                    <Card className={super.getClassName(this.props.properties)} style={{ width: '100%' }}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Reference_Schedule" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <Row style={{ margin: '0', paddingTop: '0.5rem', visibility: submode.value === '0' ? 'visible' : 'hidden' }}>
                                <Col sm={2} style={{ paddingRight: '0.5rem' }}>
                                    <Trans i18nKey="Preset_Profiles" />
                                </Col>

                                <Col style={{ display: 'flex', paddingLeft: '0', alignItems: 'center' }}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="secondary" style={{ margin: '0' }} disabled={this.props.disabled}>{this.state.countryKey}</Dropdown.Toggle>
                                        <Dropdown.Menu style={{ minWidth: "auto", fontSize: "14px" }}>
                                            <Dropdown.Item onClick={this.handleCountryDropdownChange} name={'Custom'} key={'Custom'} >{'Custom'}</Dropdown.Item>
                                            <Dropdown.Item onClick={this.handleCountryDropdownChange} name={'FR – Arrêté nuisances lumineuses'} key={'fr'} >{'FR – Arrêté nuisances lumineuses'}</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <div style={{ flexGrow: 1, paddingLeft: '10px', visibility: (this.state.countryKey === 'Custom' || submode.value != '0') ? 'hidden' : 'visible' }} ><EllipsisText text={'Warning: This predefined profile fulfills the requirements of French law “Arrêté nuisances lumineuses” regarding a project located in city of Paris and switched ON/OFF at sunset and sunrise with an average mid-point of the night around 00h45. Values have to be adjusted depending on your project characteristics. Inventronics cannot be responsible in case of misuse. First power-on cycle only for calibration. '} length={100} /></div>
                                </Col>
                            </Row>

                            <PropertyTableTimePicker
                                properties={this.props.properties}
                                extraProperties={this.props.extraProperties}
                                handleChange={this.handleChangeReferenceSchedule}
                                sizeTitle={2}
                                sizePickers={2}
                                sizeMeasureUnit={2}
                                firstRow={{ 'title': <Trans i18nKey="Output_Level" />, 'property': ASTRO_DIM.outputLevel, 'measureUnit': '%' }}
                                secondRow={{ 'title': <Trans i18nKey="Time" />, 'property': ASTRO_DIM.time, 'measureUnit': 'hh:mm' }}
                                thirdRow={{ 'title': 'Color', 'property': ASTRO_DIM8.outputColor, 'measureUnit': 'K' }}
                                displayColors={displayColors} />
                            <div style={{ paddingTop: '0.75rem', paddingLeft: '1.0rem' }}>
                                <Trans i18nKey="Energy_Savings" />: {submode.value === '2' || this.state.savings === '-1%' ? 'N/A' : this.state.savings}
                            </div>
                        </Card.Body>
                    </Card>
                </div>
                <div className="flex-row">
                    <Card className="card-feature-component" style={{ width: '100%' }}>
                        <div className="card-header-feature">
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <DraggableAreaChart
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                properties={this.props.properties}
                                dataChart={dataChart}
                                min={min}
                                max={max}
                                tickFormat={tickFormat}
                                tickValues={tickValues}
                                xThresholds={displayLocation ? [
                                    { value: new Date(1970, 0, 2, 0, this.props.midnightShift, 0), color: 'rgb(0,0,255)' },
                                ] : null}
                                xLabels={this.getXLabels(dataChart, submode)}
                                x={{ 'title': t('Time') + ' (h)' }}
                                y={{ 'title': t('Output_Level') + ' (%)' }}
                                sections={{ 0: "area-dark", 1: "area-light", 2: "area-dark", 3: "area-light", 4: "area-dark" }}
                                handleChange={this.handleChartChange} />
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }

    getXLabels(dataChart, submode) {
        const labels = [];
        const smallLabels = [];
        const ticks = [];

        if (submode.value === '2') {
            ticks.push(new Date(1970, 0, 1, 0, 0, 0));
            labels.push({ label: 'SD', x: new Date(1970, 0, 1, 0, 0, 0) });
        }

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getDataChart(properties, submode) {

        let minDimming = properties[ASTRO_DIM.outputLevel1].valueMeta.min;

        const dataChart = [];

        const minHourString = submode.value === '0' ? "13:00" : "00:00";
        const maxHourString = submode.value === '0' ? "11:00" : "24:00";

        const minHour = this.getNumberFromHour(minHourString, 0, submode);
        const maxHour = this.getNumberFromHour(maxHourString, 0, submode);

        const offsetSwitchOnFadeTime = getMinutesChart(properties[ASTRO_DIM.switchOnFadeTime].value);
        const offsetAstroDimFadeTime = getMinutesChart(properties[ASTRO_DIM.astroDimFadeTime].value)
        const offsetSwitchOffFadeTime = submode.value === '0' ? getMinutesChart(properties[ASTRO_DIM.switchOffFadeTime].value) : "0";

        let sectionCont = 0;

        if (submode.value !== '2') {
            dataChart.push({
                x: minHour,
                y: 0,
                section: sectionCont,
            });
            // point to show no fading between 0 and minDim
            dataChart.push({
                x: minHour,
                y: properties[ASTRO_DIM.outputLevel1].valueMeta.min,
                section: sectionCont,
            });
        } else {
            dataChart.push({
                x: new Date(1969, 11, 31, 22, 0, 0),
                y: 0,
                section: sectionCont,
            });

            dataChart.push({
                x: new Date(1969, 11, 31, 22, offsetSwitchOnFadeTime, 0),
                y: properties[ASTRO_DIM.outputLevel1].value || 0,
                section: sectionCont,
            });
        }

        const refArray = [
            { x: minHourString, y: properties[ASTRO_DIM.outputLevel1].value },
            { x: submode.value !== '2' ? properties[ASTRO_DIM.time2].value : "00:00", y: properties[ASTRO_DIM.outputLevel2].value },
            { x: properties[ASTRO_DIM.time3].value, y: properties[ASTRO_DIM.outputLevel3].value },
            { x: properties[ASTRO_DIM.time4].value, y: properties[ASTRO_DIM.outputLevel4].value },
            { x: properties[ASTRO_DIM.time5].value, y: properties[ASTRO_DIM.outputLevel5].value },
            { x: maxHourString, y: properties[ASTRO_DIM.outputLevel5].value },
        ];

        let firstPoint = 0;
        let lastPoint = refArray.length - 1;
        for (let i = 1; i < refArray.length - 1; i++) {

            const ref = refArray[i];
            const refValue = this.getNumberFromHour(ref.x, 0, submode);

            if (minHour > refValue) {
                firstPoint = i;
            }
            if (maxHour < refValue) {
                lastPoint = i;
            }
        }

        for (let i = firstPoint; i <= lastPoint; i++) {

            const ref = refArray[i];

            if (i === firstPoint) {

                dataChart.push({
                    x: this.getNumberFromHour(minHourString, submode.value !== '2' ? offsetSwitchOnFadeTime : 0, submode),
                    y: +ref.y || 0,
                    section: sectionCont,
                });

            } else if (i === lastPoint) {

                const prevRef = refArray[i - 1];

                dataChart.push({
                    x: this.getNumberFromHour(maxHourString, -(+offsetSwitchOffFadeTime), submode),
                    y: +prevRef.y || 0,
                    section: sectionCont,
                });

            } else {

                const prevRef = refArray[i - 1];

                dataChart.push({
                    x: this.getNumberFromHour(ref.x, 0, submode),
                    y: +prevRef.y || 0,
                    section: sectionCont,
                });

                sectionCont++;

                dataChart.push({
                    x: this.getNumberFromHour(ref.x, offsetAstroDimFadeTime, submode),
                    y: +ref.y || 0,
                    section: sectionCont,
                });

            }
        }

        dataChart.push({
            x: maxHour,
            y: properties[ASTRO_DIM.outputLevel1].valueMeta.min,
        });

        dataChart.push({
            x: maxHour,
            y: 0,
        });

        return dataChart;
    }

    getNumberFromHour(time, adding, submode, next) {
        if (submode.value === '0') {
            const momentDate = moment('1970/01/01 ' + time, 'YYYY/MM/DD HH:mm');

            momentDate.add(adding, 'minutes');

            if (momentDate.hours() < 12 && momentDate.date() === 1) {
                momentDate.add(1, 'days');
            }

            return momentDate.toDate();
        }
        else {
            const momentDate = moment('1970/01/01 ' + time, 'YYYY/MM/DD HH:mm');
            momentDate.add(adding, 'minutes');
            return momentDate.toDate();
        }
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        opmodesSelected: state.driver.opmodesSelected,
        projectLocation: state.project.location,
        issues: state.project.issueByProperty,
        midnightShift: state.project.midnightShift,
        astroSavingsValue: state.driver.astroSavingsValue
    };
};

const mapDispatchToProps = {
    fetchDriverOpmodesSelected,
    fetchDriverProperties,
    fetchAstroSavings,
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(AstroDim);
